module.exports = false;




//////////////////
// WEBPACK FOOTER
// ./~/detect-node/browser.js
// module id = 1403
// module chunks = 0